import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Comment } from 'semantic-ui-react';
import FlagModal from '../../../Flag';
import './style.scss';

const AnswerView = ({
    deleted,
    id,
    ownAnswer,
    specialty,
    text,
}) => {
    const ownActions = !deleted && (
        <Fragment>
            <span>
                {!ownAnswer &&
                    <Comment.Action className="action-right">
                        <FlagModal answerId={id} content={text} />
                    </Comment.Action>
                }
            </span>
        </Fragment>
    );

    return (
        <Fragment>
            <span className="comment-actions">
                <span className="metadata">{specialty}</span>
                {ownActions}
            </span>
            <Comment.Text>{text}</Comment.Text>
        </Fragment>);
};

AnswerView.propTypes = {
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    specialty: PropTypes.string,
    deleted: PropTypes.bool,
    ownAnswer: PropTypes.bool.isRequired,
};

AnswerView.defaultProps = {
    specialty: '',
    deleted: false,
};

export default AnswerView;
